// extracted by mini-css-extract-plugin
export var active = "_4n-2";
export var highlight = "_4n-1";
export var highlightLayer = "_4n-0";
export var issuePopover = "_4n-3";
export var statusIcon = "_4n-4";